import React, { FC, useState } from 'react';

import { request } from 'utils/request';

import { TwoFactorAuthModal } from '../../../../javascript/modals/TwoFactorAuthModal';
import { ComposingTooltipRenderProps } from 'components/UI/ComposingTooltip';
import { TxnState } from 'services/nfts';

const mintingPage = document.getElementsByClassName('js-sign-in-page')[0] as HTMLElement;

type Props = {
  handleClose: () => void;
  handleWrite: () => void;
  isMinted: boolean;
  isCreateDisabled: boolean;
  txnState: TxnState;
  showTooltip: boolean;
};

export const ModalButtons: FC<Props> = ({
  handleClose,
  handleWrite,
  isMinted,
  isCreateDisabled,
  txnState,
  showTooltip,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [intent, setIntent] = useState('');

  const checkModal = () => {
    request
      .get(`/api/internal/otp_secrets/${window.sedition.currentUser.id}/two_factor_check`)
      .then(({ data }) => {
        if (data.otp === 'inactive') {
          setIntent('enable');
        } else if (data.otp === 'active') {
          setIntent('mint-artwork');
        }
      })
      .then(() => {
        setOpenModal(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className='row'>
      {isMinted ? (
        <div className='col-12 col-md-6 col-lg-5'>
          <button className='btn btn--border-dark mb-1 mb-sm-0 w-100' onClick={handleClose}>
            Close
          </button>
        </div>
      ) : (
        <>
          <div className='col-12 col-md-5 order-lg-2'>
            <ComposingTooltipRenderProps<HTMLDivElement>
              title='You have to link a wallet and agree to T&Cs'
              visible={showTooltip}
            >
              {(ref) => (
                <div ref={ref} className='mt-1'>
                  <button
                    className='btn bg-black w-100'
                    disabled={isCreateDisabled}
                    onClick={() => checkModal()}
                  >
                    Create NFT
                  </button>
                </div>
              )}
            </ComposingTooltipRenderProps>
          </div>
          <div className='col-12 col-md-5 order-lg-1'>
            <button className='btn btn--border-dark mt-1 mb-1 mb-sm-0 w-100' onClick={handleClose}>
              {txnState === 'pending' ? 'Close' : 'Cancel'}
            </button>
          </div>
        </>
      )}
      <TwoFactorAuthModal
        openModal={openModal}
        intent={intent}
        enableType={'mint'}
        onSuccess={handleWrite}
        onClose={() => setOpenModal(false)}
      />
    </div>
  );
};
